<template>
  <slot name="prefix" />
  <component :is="tributeOptions && Object.keys(tributeOptions).length ? VueTribute : useFragment" :options="tributeOptions" class="w-full">
    <textarea
      autocomplete="off"
      :placeholder="placeHolder"
      :name="context.node.name"
      :data-testid="dataTestid"
      :id="id"
      :value="context._value"
      :class="context.classes.input"
      ref="textareaRef"
      v-bind="context.attrs"
      @input="handleInput"
    />
  </component>
  <slot name="suffix" />
</template>

<script lang="ts" setup>
import { VueTribute } from 'vue-tribute';
import { defineProps, ref, Ref, onMounted, watch } from 'vue';
import { useFragment } from '../../composables/useFragment';
import { FormKitFrameworkContext } from '@formkit/core';

interface Props {
  context: FormKitFrameworkContext;
}
const props = defineProps<Props>();

let lineHeight: number;
const dataTestid = String(props.context.dataTestid || '');
const id = String(props.context.id);
const tributeOptions = props.context.tributeOptions || {};

const placeHolder = props.context.attrs['empty-message'] || '';
const textareaRef: Ref<HTMLTextAreaElement | null> = ref(null);

const handleInput = (e: any) => {
  props.context.node.input(e.target.value);
};

onMounted(() => {
  lineHeight = textareaRef.value?.offsetHeight || 0;
  adjustHeight(props.context?._value || '');
});

watch(
  () => props.context?._value,
  () => {
    adjustHeight(props.context?._value || '');
  }
);

const adjustHeight = (text: string) => {
  if (!textareaRef.value) {
    return;
  }

  const lines = text.split(/\r*\n/).length;
  textareaRef.value.style.height = 'auto';

  if (lines > 1) {
    textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
  } else {
    textareaRef.value.style.height = `${lineHeight}px`;
  }
};
</script>
<style scoped>
textarea {
  resize: none;
  overflow: hidden;
  height: 45px;
}
</style>
<style>
.tribute-container {
  @apply absolute top-0 left-0 z-10 block h-auto overflow-y-auto;
}

.tribute-container ul {
  @apply p-2 bg-white border shadow-lg w-max border-slate-300 dark:border-zinc-700 dark:bg-zinc-900 rounded-10;
}

.tribute-container li {
  @apply cursor-pointer gap-2 px-2 py-2 text-sm font-bold rounded-sm hover:bg-slate-100 dark:hover:bg-zinc-700 active:bg-slate-300 dark:text-zinc-300 dark:hover:text-zinc-300;
}

.tribute-container li.highlight {
  @apply hover:bg-slate-100 dark:hover:bg-zinc-700;
}

.tribute-container span {
  @apply underline;
}

.tribute-container span.no-match {
  @apply cursor-default;
}

.tribute-container .menu-highlighted {
  @apply font-bold;
}
</style>
